import { render, staticRenderFns } from "./BrandSkusTable.vue?vue&type=template&id=1a773d46&scoped=true&"
import script from "./BrandSkusTable.vue?vue&type=script&lang=ts&"
export * from "./BrandSkusTable.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSkusTable.vue?vue&type=style&index=0&id=1a773d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a773d46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
